import { useEffect, useState } from "react";
import api from "@/lib/api";

// Last 20 admin broadcasts with sent counts.
export default function BroadcastHistory({ refreshKey }) {
  const [rows, setRows] = useState([]);
  useEffect(() => {
    api.get("/admin/broadcast/history").then(({ data }) => setRows(data || [])).catch(() => {});
  }, [refreshKey]);
  if (!rows.length) return null;
  return (
    <div className="rounded-2xl border border-white/10 bg-surface overflow-hidden" data-testid="broadcast-history">
      <p className="px-5 py-3 text-xs uppercase tracking-widest text-foreground/50 border-b border-white/5">Recent broadcasts</p>
      <div className="divide-y divide-white/5">
        {rows.map((b) => (
          <div key={b.id} className="px-5 py-3 flex flex-wrap items-center gap-x-4 gap-y-1 text-sm" data-testid={`broadcast-row-${b.id}`}>
            <span className="font-medium truncate max-w-[280px]">{b.subject}</span>
            <span className="text-foreground/55">{b.group_label}</span>
            <span className="text-foreground/55">{new Date(b.created_at).toLocaleString()}</span>
            <span className={`ml-auto text-xs font-semibold ${b.status === "done" ? "text-emerald-400" : "text-gold"}`}>
              {b.status === "done" ? `${b.sent} sent${b.failed ? ` · ${b.failed} failed` : ""}` : `Sending ${b.sent}/${b.total}`}
            </span>
          </div>
        ))}
      </div>
    </div>
  );
}
